import React from "react";
import Plan from "../components/Plan";
import Background from "../components/Background";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import Switch from "react-switch";
import { useState } from "react";

const PLANS = [
  {
    title: "Free",
    desc: "Analyse your file, with the best malware classification model for free",
    month: 0,
    year: 0,
    data: ["20 requests per day", "Rescan files"],
    color: "bg-nucleon-100",
  },
  {
    title: "Standard",
    desc: "Analyse your file, with the best malware classification model",
    month: 700,
    year: 6972,
    data: [
      "1000 requests per day",
      "Rescan files",
      "Keep your files private",
      "Download malware samples",
    ],
    color: "bg-nucleon-700",
    link: "https://marketplace.ovhcloud.com/p/nucleon-malprob-detection-malware-ransomware",
    message: "Buy now",
  },
  {
    title: "Pro",
    desc: "Analyse your file, with the best malware classification model with high priority",
    month: 3500,
    year: 32340,
    data: [
      "5000 requests per day",
      "Rescan files",
      "Keep your files private",
      "Download malware samples",
      "High priority for analysis",
    ],
    color: "bg-nucleon-800",
    link: "https://marketplace.ovhcloud.com/p/nucleon-malprob-detection-malware-ransomware",
    message: "Buy now",
  },
  {
    title: "Enterprise",
    desc: "Analyse your file, with the best malware classification model with unlimited access",
    month: -1,
    year: -1,
    data: [
      "Unlimited requests per day",
      "Rescan files",
      "Keep your files private",
      "Download malware samples",
      "High priority for analysis",
      "Custom integration",
    ],
    color: "bg-nucleon-1100",
    link: "https://nucleon-security.com/contact-us/",
    message: "Contact-us",
  },
];

function Pricing() {
  const [year, setYear] = useState(false);
  return (
    <>
      <div className="flex flex-col w-full min-h-screen">
        <Navbar />
        <div className="grow">
          <Background styling="flex justify-items-center w-full p-20 pb-36 grid items-center">
            <h1 className="text-6xl text-center font-bold text-white">
              Pricing
            </h1>
            <div
              className="mt-7 grid items-center gap-2.5 "
              style={{ gridTemplateColumns: "1fr auto 1fr" }}
            >
              <h1 className="text-xl text-center text-white/75">Pay monthly</h1>
              <Switch
                onChange={() => setYear(!year)}
                checked={year}
                onColor={"#30CFF2"}
                uncheckedIcon={false}
                checkedIcon={false}
                height={32}
                width={58}
              />
              <h1 className="text-xl text-center font-semibold text-nucleon-100">
                Pay yearly
              </h1>
            </div>
          </Background>
          <div className="grid justify-items-center">
            <div className="relative -top-20 px-20 grid lg:grid-cols-4 gap-10 justify-items-center">
              {PLANS.map((plan, key) => {
                return (
                  <Plan
                    key={key}
                    title={plan.title}
                    desc={plan.desc}
                    price={year ? plan.year : plan.month}
                    year={year}
                    data={plan.data}
                    color={plan.color}
                    message={plan.message}
                    link={plan.link}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Pricing;
